import { cssClass } from '../../style';

export namespace ShareContentButtonStyles {
  const cssPrefix = 'ShareContentButtonStyles';

  export const root = cssClass(cssPrefix, 'root', {
    padding: 0,
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  });

  export const text = cssClass(cssPrefix, 'text', {
    marginLeft: '4px',
    paddingRight: '2px'
  });
}
